
import * as React from "react";
import $ from "jquery";
import { Api } from "../../../lib/Api";
import { TStorage } from "../../../../avernus/tstorage/TStorage";
import { IPermisionForInterface } from "../../../interfaces/IPermission";
import UserRegistration, { IRegistrationSaveUser } from "../registration/UserRegistration";
import ResetPassword from "./ResetPassword";
import { Lng } from "../../../../languages/Languages";
import RegCheckboxes from "../../global/RegCheckboxes";
import { Order } from "../../user/Order";

interface ILoginProps {
    setUrl:any
}
interface IForm{
    userName:string
    password:string
}
type IView = 'loginSelector'|'serviceLogin'|'userLogin'|'registration'|'userRegistration'|'serviceRegistration'|'forgotPassword'|'passwordReset';

interface ILoginState {
    error              : string
    form               : IForm
    loading            : boolean
    view               : IView
    previousView       : IView
    openCheckboxesModal: boolean
    acceptedAll        : boolean
    version            : number
}

interface ILoginResult{
    error       : string;
    api_token   : string;
    permission  : IPermisionForInterface;
    name        : string;
    redirectUrl : string;
    tokenError  : boolean;
    restaurants :Array<IRestaurant>
    user        :IRestaurant
}

interface IRestaurant{
    id  : number
    name: string
}


export default class Login extends React.Component<ILoginProps, ILoginState>{

    constructor(props:ILoginProps){
        super(props);
        this.state = {
            version: 0,
            error: null,
            form: {
                userName: '',
                password: ''
            },
            loading            : false,
            openCheckboxesModal: false,
            acceptedAll        : false,
            view: 'loginSelector',
            previousView: 'loginSelector'
        };
    }

    private changeInputHandler(evt, type:string): void {
        evt.preventDefault();
        var form = this.state.form;
        form[type] = evt.target.value;
        this.setState({
            form: form
        });

    }

    public login(e):void{
        e.preventDefault();
        this.setState({
            loading: true
        }, () =>{
            this.loginMethod(this.state.form.userName, this.state.form.password);
        });
    }

    private successRegistration(userName:string, password:string):void{
        this.setState({
            loading: true,
            view: 'loginSelector'
        }, () =>{
            if ( document.querySelector('.modal-backdrop') !== null ) {
                $('.modal-backdrop').remove();
            }
            this.loginMethod(userName, password);
        });
    }

    private loginMethod(userName:string, password:string):void{
        Api.cleanStorage(); //remove all older data
        Api.call('/login', {
            userName: userName,
            password: password
        }, (result) =>{
            if ( result.api_token !== undefined && result.api_token !== null && result.restaurants !== undefined ) {
                Api.setPermission(result.permission);
                Api.setToken(result.api_token);
                Api.setRestaurants(result.restaurants);
                Api.setUser(result.user);
                new TStorage().set('name', result.name);
                this.setState({
                    error: null,
                }, () =>{
                    let redirectUrl:string = null;
                    if ( result.redirectUrl !== null ) {
                        redirectUrl = result.redirectUrl;
                    }
                    if ( Api.isFrontUser() && Order.getOffers().length > 0 ) {
                        redirectUrl = '/user/payment';
                    }

                    this.props.setUrl(redirectUrl); //last url
                });

            }else{
                var error = result.error;
                if ( result.tokenError !== undefined ) {
                    error = result.tokenError?'Wrong token':'';
                }
                this.setState({
                    error: result.error,
                    loading: false
                });
            }
        });
    }

    private registrationClickHandler(evt, view:IView): void {
        evt.preventDefault();
        this.setState({
            previousView: this.state.view,
            view: view,
            openCheckboxesModal: false
        });
    }

    public changeView(evt, view:IView): void
    {
        evt.preventDefault();
        this.setState({
            previousView: this.state.view,
            view: view,
        });
    }


    render() {
        let view = this.state.view;
        document.body.classList.remove('registration');
        if ( this.state.openCheckboxesModal === true ) {
            setTimeout(() => {
                if ( document.querySelector('#open_checkboxes_modal') !== null ) {
                    $('#open_checkboxes_modal').modal({show:true});
                }
            }, 200);
        }
        return (
            <>
                { view === 'loginSelector'?this.loginSelector():'' }
                { view === 'userLogin'?this.loginBox():'' }
                { view === 'serviceLogin'?this.loginBox():'' }

                { view === 'forgotPassword'?this.registration():'' }

                { view === 'registration'?this.registration():'' }

                { view === 'userRegistration'?this.registration():'' }
                { view === 'serviceRegistration'?this.registration():'' }

			</>
        );
    }

    private registration() {
        let view = this.state.view;
        document.body.classList.remove('login_page');
        document.body.classList.add('registration_page');
        return (
            <div className="registration_box">
                <div>
                    <div className="illustration">
                        {
                            (this.state.previousView == 'userRegistration' || this.state.view == 'userRegistration' ) &&
                            <img src="img/opus_logo_inverse.png" />
                        }

                        {
                            this.state.previousView == 'serviceRegistration' || this.state.view == 'serviceRegistration' &&
                            <img src="img/opus_logo_normal.png" />
                        }
                    </div>
                    <div className="registration_main_div">
                        { view == 'forgotPassword' && <h1>{Lng.get('resetpw_titel')}</h1>}

                        <div className = "content">
                            {
                                view == 'registration' &&
                                <>
                                    <div className="row">
                                        <div className="col-12">
                                            <button className="purple_btn" type="button" onClick={e => this.registrationClickHandler(e, 'userRegistration')}>{Lng.get('user_reg')}</button>
                                        </div>
                                        <div className="col-12 mt-4">
                                            <button className="green_btn" type="button" onClick={e => this.registrationClickHandler(e, 'serviceRegistration')}>{Lng.get('restaurant_reg')}</button>
                                        </div>
                                    </div>

                                    </>
                            }
                            { view === 'userRegistration' &&
                                <UserRegistration
                                    setUrl={this.props.setUrl}
                                    title={Lng.get('userreg_title')}
                                    type={'user'}
                                    successRegistration={(userName, password) => this.successRegistration(userName, password)}/>
                            }
                            { view === 'serviceRegistration' &&
                                <UserRegistration
                                    setUrl={this.props.setUrl}
                                    title={Lng.get('userreg_rest_title')}
                                    type = {'professional'}
                                    successRegistration={ (userName, password) => this.successRegistration(userName, password) } />
                            }
                            { view === 'forgotPassword' && <ResetPassword/> }

                            <div className="row">
                                <div className="col-12">
                                    <button className="back_btn red_btn" type="button" onClick={e => this.registrationClickHandler(e, 'loginSelector')}>{Lng.get('back_to_login')}</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }

    private loginBox() {
        document.body.classList.add('login_page');
        document.body.classList.remove('registration_page');
        document.body.classList.add(this.state.view);
        if ( this.state.error !== null ) {
            setTimeout(() =>{
                document.querySelector('form').style.bottom = '0';
            }, 100);
        }
        return <>
        <div className="login_box">
            <div>
                <div className="illustration">
                    {
                        (this.state.view == 'userLogin' || this.state.view == 'userRegistration' ) &&
                        <img src="img/opus_logo_inverse.png" />
                    }

                    {
                        (this.state.view == 'serviceLogin' || this.state.view == 'serviceRegistration') &&
                        <img src="img/opus_logo_normal.png" />
                    }

                </div>
                <div className="login_main_div">
                    <h1>
                        Professional help
                        in-house
                    </h1>
                    <div className = "content">
                        <form method="post" onSubmit={e => this.login(e)}>
                            <div className="form-group">
                                <input type="text" className="s-form-control" value={this.state.form.userName} onChange={(e) => this.changeInputHandler(e, 'userName')} placeholder={Lng.get('username')} required={true} />
                            </div>
                            <div className="form-group">
                                <input type="password" className="s-form-control" value={this.state.form.password} onChange={(e) => this.changeInputHandler(e, 'password')} placeholder={Lng.get('password')} required={true} />
                            </div>
                            {this.state.error !== null ? <div className="alert alert-danger">
                                {this.state.error}
                            </div> : ''}
                            <div className="form-group">
                                {this.state.loading === true ? <button className="purple_btn" disabled={true} type="submit">Loading...</button> : <button className="purple_btn" type="submit">{Lng.get('login')}</button>}
                                {this.state.loading === true ? '' : <a className="btn-link forgot_password_btn" onClick={e => this.registrationClickHandler(e, 'forgotPassword', )}>{Lng.get('forgot_password?')}</a>}
                                {this.state.loading === true ? '' : <div className = "registration-box"><span>Don't have an account? </span><a className="btn-link registration_btn" type="button" onClick={e => this.registrationClickHandler(e, 'registration')}>{Lng.get('registration')}</a></div>}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        </>;
    }

    private loginSelector() {
        document.body.classList.add('login_selector_page');
        document.body.classList.remove('registration_page');
        return <>
            <div className="login_selector_box">
                <div>
                    <div className="illustration"/>
                    <div className = "login_selector_main_div">
                        <button className="green_btn" onClick={ (e) => this.changeView(e, 'userLogin') } >
                            Log in as a User
                        </button>
                        <button className="light_purple_btn" onClick={ (e) => this.changeView(e, 'serviceLogin') }>
                            Log in as a Service Provider
                        </button>
                        <button className="blue_btn">
                            About the Opus
                        </button>
                    </div>
                </div>

            </div>
        </>;
    }


}
